import 'reflect-metadata';
import { 
    IValidateMetaData, 
    VALIDATEPROPERTY__METADATA_KEY 
} from '../models/utilities/validate-property';
import { AppUtils } from './app-utils';

/**
 * Utility class for handling validation of TS models
 */
export class ModelValidator {

    /**
     * Validate a TS class baesd on its configured rules
     * @param obj The TS class to validate
     */
    public static validate<T>(obj: any) : any {

        const msgs : any = {};

        if (typeof obj === "string") {
            return;
        }

        Object.keys(obj).forEach((key) => {
            const propertyMetadata = ModelValidator.getValidateProperty(obj, key);
            if (propertyMetadata) {
                const tmpMsgs = ModelValidator.validateProperty(propertyMetadata, obj, key);  
                if (tmpMsgs && tmpMsgs.length > 0) {
                    msgs[key] = tmpMsgs;
                }
            } 
        });

        return msgs;
    }

    /**
     * Validate the given jsonObject based on the rules it defined
     * @param propMetadata The property metadata specified on the model
     * @param obj The class instance we're validating
     * @param key The property name we're iterating on
     */
    private static validateProperty(propMetadata: any, obj: any, key: string) {

        const propertyName = propMetadata.name || key;
        const propValue = obj[propertyName];
        const clazz = AppUtils.getToClass(obj, key);

        if (AppUtils.isArray(clazz) || AppUtils.isArray(propValue)) {

            // Map the children of the array
            const childMessages = propValue.map(
                (item: any) => ModelValidator.validate(item)
            );

            // Min children Validator
            if (propMetadata.minChildren && propValue.length < propMetadata.minChildren) {
                return (`${ AppUtils.ToTitleCase(key) } must have at least ${ propMetadata.minChildren } entries.`);
            }
            else {

                const tms = childMessages.filter((itm: any) => {
                    return !AppUtils.IsEmpty(itm);
                });

                return tms;
            }
        }
        else {
            
            const msgs : string[] = [];

                // Required Validator
                if (propMetadata.requiredFn) {
                    if (propMetadata.requiredFn(obj) && !
                       (propValue !== undefined && propValue !== null && propValue !== '')) {
                       msgs.push(`This field is required`); 
                    }
                }
                else if (propMetadata.required && (propValue === undefined || propValue === null || propValue === '')) {
                    msgs.push(`This field is required`);
                }

                // Max Length Validator
                if (propMetadata.positiveNumber && (propValue >=  0)) {
                    msgs.push(`This field must be less than ${ propMetadata.maxLength} characters.`);
                }

                // Max Length Validator
                if (propMetadata.maxLength && (propValue.length > propMetadata.maxLength)) {
                     msgs.push(`This field must be less than ${ propMetadata.maxLength} characters.`);
                }

                // Min Length Validator
                if (propMetadata.minLength && (propValue.length < propMetadata.minLength)) {
                    msgs.push(`This field must be more than ${ propMetadata.minLength } characters.`);
                }
                
            return msgs;
        }

    }

    private static getValidateProperty<T>(target: any, propertyKey: string): IValidateMetaData<T> {
        return Reflect.getMetadata(VALIDATEPROPERTY__METADATA_KEY, target, propertyKey);
    }
}
